document.addEventListener('click', ({ target }) => {
  if (target.closest('.sidepanel--scrim')) {
    if (document.querySelector('[data-sidepanel="open"]')) {
      Sidepanel.close()
    } else if (document.querySelector('[data-booking-details-sidepanel="open"]')) {
      const bookingSidePanelCloseButton = document.querySelector('.booking-manager__sidepanel .content .sidepannel--container-close') || document.querySelector('.booking-manager__sidepanel .sidepannel--container-close')
      bookingSidePanelCloseButton.click()
    }
  }
});
